import { render, staticRenderFns } from "./atualizacaoValoresProduto.vue?vue&type=template&id=6d7d27ef"
import script from "./atualizacaoValoresProduto.ts?vue&type=script&lang=js&external"
export * from "./atualizacaoValoresProduto.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d7d27ef')) {
      api.createRecord('6d7d27ef', component.options)
    } else {
      api.reload('6d7d27ef', component.options)
    }
    module.hot.accept("./atualizacaoValoresProduto.vue?vue&type=template&id=6d7d27ef", function () {
      api.rerender('6d7d27ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/atualizacaoValores/atualizacaoValoresProduto.vue"
export default component.exports